<template>
	<div class="DashboardBuildings">
		<div class="DashboardBuildings-Headers is-flex is-justify-content-space-between px-0">
			<ui-text-field v-model="buildingSearchInput" placeholder="Byggnad x"></ui-text-field>

			<div class=" is-flex is-flex-direction-row-reverse pr-0 is-align-items-center">
				<i
					class="fas ml-2"
					:class="`fa-arrow-${sortOrder === 'desc' ? 'down' : 'up'}`"
					@click="handleSortOrderClick"
				/>

				<select class="select mr-0 pr-0" @change="handleSortSelection">
					<option value="name">Namn</option>
					<option value="lastRoundHistory">Senaste Kontroll</option>
					<option value="flaws">Brister</option>
				</select>

				<label
					class="is-size-7"
					style="line-height: 2rem; margin-right: .6rem;"
				>
					Sortera efter:
				</label>
			</div>
		</div>

		<div v-for="building in comBuildings"
			:key="building.id"
			@click="setBuilding(building)"
			:class="['DashboardBuildings-Building', { 'DashboardBuildings-Building--active': getActiveBuilding?.id === building.id }]"
		>
			<div class="dashboard-table__row">
				<div class="table-row__name-column">
					<p>
						{{ building.name }}
					</p>
				</div>

				<div class="table-row__information-column">
					<p class="is-size-7">
						{{ building.flaws + building.questions }} brister
					</p>
					<p class="is-size-7" >
						{{ getLatestRunText(building) }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	props: {
		buildings: {
			type: Array,
			default: () => []
		}
	},

	data: () => ({
		sort: 'name',
		sortOrder: '',
		buildingSearchInput: ''
	}),

	computed: {
		...mapGetters('user', ['getActiveBuilding']),

		comBuildings() {
			let tempBuildings = [...this.buildings];

			if (this.searchInput !== '')
				tempBuildings = tempBuildings.filter(x => x.name.toUpperCase().includes(this.buildingSearchInput.toUpperCase()));

			return this.sortBy(
				tempBuildings,
				`${this.sort}${this.sortOrder === 'desc' ? ' desc' : ''}`);
		}

	},

	methods: {
		...mapActions('user', ['setActiveBuilding']),

		setBuilding(building) {
			if (this.getActiveBuilding?.id === building.id)
				return this.setActiveBuilding(null);

			this.setActiveBuilding(building);
		},

		handleSortSelection(e) {
			const column = e.target.value.trim();

			if (this.sort === column)
				this.sortOrder = 'desc';
			else
				this.sortOrder = 'asc';

			this.sort = column;
		},

		handleSortOrderClick() {
			this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
		},

		getLatestRunText(building) {
			if (!building.lastCompletedRoundHistory && !building.lastNotFullyCompletedRoundHistory)
				return 'Ej kontrollerad';

			const lastCompletedRoundHistoryDate = building.lastCompletedRoundHistory
				? new Date(building.lastCompletedRoundHistory)
				: new Date('1900-01-01');

			const lastNotFullyCompletedRoundHistoryDate = building.lastNotFullyCompletedRoundHistory
				? new Date(building.lastNotFullyCompletedRoundHistory)
				: new Date('1900-01-01');

			return lastCompletedRoundHistoryDate > lastNotFullyCompletedRoundHistoryDate
				? `Kontrollerad ${this.$utils.date.lastCheckedFormatted(building.lastCompletedRoundHistory)}`
				: `Delvis kontrollerad ${this.$utils.date.lastCheckedFormatted(building.lastNotFullyCompletedRoundHistory)}`;
		}
	}
};
</script>

<style lang="scss" scoped>
.DashboardBuildings-Headers {
	padding: 10px;
	flex-wrap: wrap;

	i {
		pointer-events: unset !important;

		&:hover {
			cursor: pointer !important;
		}
	}

	> div {
		margin-bottom: 1rem;

		&:first-child {
			margin-right: 1rem;
			min-width: 150px;
		}

		&:nth-child(2) {
			margin-left: auto;

			> label {
				white-space: nowrap;
			}
		}
	}
}

.DashboardBuildings-Building {
	cursor: pointer;
	padding: 10px;
	border-radius: 4px;
	background-color: #4d535d;
	margin-bottom: 10px;
	box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
	transition: background-color 0.3s ease;


	&:hover {
		transition: background-color 0.3s ease;
		background-color: lighten(#4d535d, 10%);
	}
}

.DashboardBuildings-Building--active {
	background-color: #e66f1f;
	&:hover {
		background-color: #e66f1f;
	}
}

.column-header {
	&:hover {
		cursor: pointer;
	}
}
</style>
